import { NgModule, Optional, SkipSelf } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { COMPONENTS } from './components';
import { routes } from './users.routes';
import {
  UserActivateDialogComponent
} from './components/user-list/user-activate-dialog/user-activate-dialog.component';
import {
  UserDeactivateDialogComponent
} from './components/user-list/user-deactivate-dialog/user-deactivate-dialog.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgSelectModule } from '@ng-select/ng-select';

import { TranslateModule } from '@ngx-translate/core';
import { UsersLoginResolver } from '@shared/resolvers/users-login.resolver';

@NgModule({
  declarations: [...COMPONENTS, UserActivateDialogComponent, UserDeactivateDialogComponent],
  imports: [RouterModule.forChild(routes), SharedModule, FormsModule, MatProgressBarModule, NgSelectModule, TranslateModule],
  providers: [UsersLoginResolver]
})
export class UsersModule {
  constructor(@Optional() @SkipSelf() parentModule?: UsersModule) {
    if (parentModule) {
      throw new Error('UsersModule is already loaded. Import it in the AppModule only');
    }
  }
}
